import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API } from "aws-amplify";
import { formatNumber, handleState } from "../../Utils/utils";
import {
  addClient,
  alert,
  modalAside,
  stateAlert,
} from "../../Store/simulate/actions";
import { decryptEstandar } from "../../Utils/CryptographyUtils";
import Table from "./Table";
import IconDownload from "../../Resources/svg/Icons/IconDownload";
import IconReport from "../../Resources/svg/Icons/IconReport";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import Flags from "./Flags";
import { meses } from "../../Utils/aprobaciones/month";
import Loading from "../loading";

const TableAprovations = ({ data, codProd, setModalData }) => {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const asesor = useSelector((state) => decryptEstandar(state.login.username));

  const [linkPdf, setLinkPdf] = useState("");

  const elem = useRef(null);

  const codigo = codProd;

  const onClickRevisar = (item) => {
    if (["IG", "UC"].includes(codProd)) {
      if (
        item.estado !== "pendiente" &&
        item.estado !== "porFirmar" &&
        item.estado !== "revision"
      ) {
        setModalData(item);
        dispatch(modalAside(true));
      } else {
        history.push({
          pathname: "/aprobaciones/aprobacion",
          state: item,
          ri: true,
        });
      }
    } else if (["AS", "UC"].includes(codProd)) {
      if (item.estado !== "pendiente" && item.estado !== "porFirmar") {
        setModalData(item);
        dispatch(modalAside(true));
      } else {
        history.push({
          pathname: "/aprobaciones/aprobacion",
          state: item,
          ri: true,
        });
      }
    } else {
      dispatch(addClient(item));
      history.push("/aprobaciones/verificacion");
    }
  };

  const generatePdfSimulate = async (data) => {
    setIsLoading(true);

    dispatch(
      alert({
        type: "success",
        title: "¡Listo, descarga completa!",
        message: ``,
      })
    );

    const response = await API.get(
      "api-rentas",
      "/generate-pdf/" + data.idCotizacion
    );

    if (response.status) {
      setLinkPdf(response.data);
      setIsLoading(false);
      dispatch(stateAlert(true));
      setTimeout(() => {
        dispatch(stateAlert(false));
      }, 4000);
    } else {
      setIsLoading(false);
      dispatch(stateAlert(false));
    }
  };

  const availableBottons = (item) => {
    return (
      item.estado !== "Vencida" &&
      ["AS", "IG", "UC", "RG"].includes(item.producto.codigo)
    );
  };

  useEffect(() => {
    if (linkPdf) {
      setTimeout(() => {
        elem.current.click();
      }, 3000);
    }
  }, [linkPdf]);

  return (
    <div className="table-box">
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={linkPdf}
        ref={elem}
      />
      <Table>
        <thead>
          <tr>
            <th width="96px">Nº DE COTIZACION</th>
            <th width={`${codigo === "IG" ? "128" : ""}`}>CONTRATANTE</th>
            <th>DNI / CE</th>
            {codigo === "IG" || (codigo === "UC" && <th>VENCIMIENTO</th>)}
            <th>PRIMA COMERCIAL</th>
            {codigo === "IG" || codigo === "UC" ? (
              <>
                <th width="110">Portafolio</th>
              </>
            ) : (
              <th width="110">TASA</th>
            )}
            <th width="110">NRO. DE Póliza</th>
            <th width="150">ESTADO</th>
            <th>ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((item, index) => (
              <tr key={index}>
                <td>{item.numCotizacion || item.datosCliente.documento}</td>

                {/* <td>{getTitleCase(item.datosCliente.nombres) || ""}</td> */}                                                              
                { item.contratante ? (<td>{ Object.keys(item.contratante).length === 0 ? getTitleCase(item.datosCliente.nombres) : item.contratante.typeContractor == 'PERSON' ? getTitleCase(item.contratante.names +  ' ' + item.contratante.firstName + ' ' + item.contratante.lastName ) : item.contratante.companyName }</td>) : <td>{getTitleCase(item.datosCliente.nombres) || ""}</td>}
                <td>{item.datosCliente.documento}</td>
                {item.producto.codigo === "IG" ||
                  (item.producto.codigo === "UC" && (
                    <td>
                      {item.datosCotizacion.vencimiento.split("-")[0]}{" "}
                      {
                        meses[
                          item.datosCotizacion.vencimiento
                            ? item.datosCotizacion.vencimiento.split("-")[1] - 1
                            : "-"
                        ]
                      }{" "}
                      {item.datosCotizacion.vencimiento.split("-")[2]
                        ? item.datosCotizacion.vencimiento.split("-")[2]
                        : "-"}
                    </td>
                  ))}
                <td>
                  {item.datosCotizacion.moneda && (
                    <>{item.datosCotizacion.moneda.simbolo}&nbsp;</>
                  )}
                  {formatNumber.new(item.datosCotizacion.prima)}
                </td>
                {item.producto.codigo === "IG" ||
                item.producto.codigo === "UC" ? (
                  <>
                    <td>
                      {item.datosCliente.portafolio
                        ? item.datosCliente.portafolio
                        : "-"}
                    </td>
                  </>
                ) : (
                  <td>
                    {item.datosCotizacion.tasa !== null && (
                      <>{item.datosCotizacion.tasa}%</>
                    )}
                  </td>
                )}
                <td>{item.datosEmision ? item.datosEmision.numPoliza : "-"}</td>
                <td>
                  <Flags variant={item.estado}>
                    {handleState(item.estado)}
                  </Flags>
                </td>
                <td>
                  <div className="action-container">
                    {availableBottons(item) && (
                      <div
                        className="action-container__item"
                        onClick={() => onClickRevisar(item)}
                      >
                        <IconReport />
                        <span>Revisar</span>
                      </div>
                    )}

                    {availableBottons(item) && (
                      <div
                        className="action-container__item"
                        onClick={() => generatePdfSimulate({ ...item, asesor })}
                      >
                        <IconDownload />
                        <span>Descargar</span>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      {isLoading && <Loading  />}
    </div>
  );
};

export default TableAprovations;
